import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

// useResolveReview translates the URL triplet (tenant/repo/reviewName) the
// SPA carries in the path into the underlying reviewId. The detail and diff
// pages call this once on mount; every downstream hook (useFindings,
// useTimeline, …) keeps taking reviewId.
export function useResolveReview(
  tenant: string | undefined,
  repo: string | undefined,
  reviewName: string | undefined,
) {
  return useQuery({
    queryKey: ['resolveReview', tenant, repo, reviewName] as const,
    queryFn: () => api.resolveReview(tenant!, repo!, reviewName!),
    enabled: Boolean(tenant && repo && reviewName),
  })
}
